import { render } from "./StudentMaster.vue?vue&type=template&id=3c0f1d08&scoped=true"
import script from "./StudentMaster.vue?vue&type=script&lang=js"
export * from "./StudentMaster.vue?vue&type=script&lang=js"

import "./StudentMaster.vue?vue&type=style&index=0&id=3c0f1d08&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\City Hoardings\\City_Hoardings_UI\\ui-admin-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c0f1d08"]])

export default __exports__